import {Brain, Scan, Syringe} from 'lucide-react'

const CARDS = [
  {
    icon: Scan,
    title: 'Semicolon Tattoo Cost',
    priceRange: '$50 - $150',
    description: 'A small, meaningful symbol tattoo typically taking under 30 minutes. Priced at studio minimums for most artists, with slight increases for custom lettering pairings.',
  },
  {
    icon: Brain,
    title: 'Hairline Scalp Micropigmentation',
    priceRange: '$800 - $3,500',
    description: 'Male hairline tattoo cost varies by density and coverage area. Full scalp sessions run higher due to specialized pigments and multiple touch-up appointments required.',
  },
  {
    icon: Syringe,
    title: 'Under Anesthesia Tattoo Sessions',
    priceRange: '+$200 - $600 fee',
    description: 'Tattoo under anesthesia cost adds a medical supervision fee on top of standard rates, typically used for large-scale or highly sensitive-area sessions requiring an anesthesiologist.',
  },
]

function NicheCards() {
  return (
    <section id="niche-styles" className="bg-[#0a0908] px-4 py-20 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-serif text-3xl font-bold text-white sm:text-4xl">
            Niche Design & Procedure Pricing
          </h2>
          <p className="mt-3 text-slate-400">
            Specialized pricing for high-demand styles and procedures our calculators don&apos;t fully capture.
          </p>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {CARDS.map(card => {
            const Icon = card.icon
            return (
              <div
                key={card.title}
                className="group rounded-2xl border border-white/10 bg-white/[0.03] p-7 transition-colors hover:border-amber-500/30 hover:bg-white/[0.05]"
              >
                <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-amber-500/10 text-amber-400 transition-colors group-hover:bg-amber-500/20">
                  <Icon className="h-6 w-6" aria-hidden="true" />
                </div>
                <h3 className="font-serif text-lg font-semibold text-white">{card.title}</h3>
                <p className="mt-2 font-serif text-2xl font-bold text-amber-400">{card.priceRange}</p>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{card.description}</p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default NicheCards
